<template>
  <div class="homelayout">
    <layoutheader ref="header"></layoutheader>
    <div class="bodymain">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <Layoutfooter ref="footer"></Layoutfooter>
    <div class="floatright">
      <div @click="topath('/chat')">
        <img
          style="width: 170px; height: 170px"
          src="@/assets/img/chat/gaokaoAi.gif"
          alt=""
        />
      </div>
    </div>
    <div class="floatleft">
      <div @click="topath('/volunteerForm')">
        <img src="@/assets/img/index/index (11).png" alt="" />
        <p>志愿表</p>
        <div class="sup" v-if="$store.state.volunteerSum > 0">
          {{ $store.state.volunteerSum }}
        </div>
      </div>
      <div @click="topath('/schoolComparison')">
        <img src="@/assets/img/index/index (22).png" alt="" />
        <p>院校对比</p>
        <div class="sup" v-if="$store.state.contrastList.length > 0">
          {{ $store.state.contrastList.length }}
        </div>
      </div>
      <div @click="topath('/information')">
        <img src="@/assets/img/index/index (20).png" alt="" />
        <p>高考资讯</p>
      </div>
      <div
        @mouseenter="phonemouseout"
        @mouseleave="phonemouseover"
        class="phone"
      >
        <img src="@/assets/img/index/index (23).png" alt="" />
        <p>联系我们</p>
        <div :class="{ current: phonestate }">
          <p v-for="item in adminphone">{{ item.value }}</p>
        </div>
      </div>

      <div @click="toTop">
        <img src="@/assets/img/index/index (21).png" alt="" />
        <p>回到顶部</p>
      </div>
    </div>
  </div>
</template>

<script>
import layoutheader from "./Header";
import Layoutfooter from "./Footer";
import { BaseMixin } from "@/mixins/basemixin";
import { queryAllDictItems, ajaxGetDictItems, gkYClassList } from "@/api/api";
export default {
  name: "CompanyLayout",
  mixins: [BaseMixin],
  components: {
    layoutheader,
    Layoutfooter,
  },

  data() {
    return {
      timeline: [],
      phonestate: false,
      adminphone: [],
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.getqueryAllDictItems();
    this.$store.commit("setloginstate", false);
    ajaxGetDictItems("admin_phone").then((res) => {
      // console.log(res);
      if (res.success) {
        this.adminphone = res.result;
      }
    });
    if (this.$store.state.userinfo) {
      this.$store.dispatch("getAlreadyAsp");
    }
  },
  mounted() {},
  methods: {
    phonemouseout() {
      //鼠标移入
      this.phonestate = true;
    },
    phonemouseover() {
      //鼠标移出
      this.phonestate = false;
    },
    getqueryAllDictItems() {
      queryAllDictItems().then((res) => {
        if (res.success) {
          this.$store.commit("setdictionary", res.result);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    topath(path) {
      console.log(path);
      if (path == "/chat" && !this.$store.state.userinfo) {
        this.$store.commit("setloginstate", true);
        return false;
      }
      if (
        path == "/chat" &&
        this.$store.state.userinfo &&
        parseInt(this.$store.state.userinfo.membershipType) == 0
      ) {
        // // setmembertype  0会员 1次数
        // this.$store.commit("setmembertype", 0);
        this.$store.commit("setmemberstate", true);
        return false;
      }
      if (path == "/volunteerForm" && !this.$store.state.userinfo) {
        this.$store.commit("setloginstate", true);
        return false;
      }
      // if (path == "/volunteerForm" && this.$store.state.userinfo.membershipType == 0) {
      //   this.$store.commit("setmembertype", 0);
      //   this.$store.commit("setmemberstate", true);
      //   return false;
      // }
      if (
        path == "/information" &&
        this.$store.state.userinfo &&
        parseInt(this.$store.state.userinfo.membershipType) == 0
      ) {
        // // setmembertype  0会员 1次数
        // this.$store.commit("setmembertype", 0);
        // this.$store.commit("setmemberstate", true);
        // return false;
      }
      if (this.$route.path == path) return false;
      let routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
    },
    toTop() {
      let elementDiv = document.getElementsByTagName("html")[0];
      elementDiv.scrollTo({
        //滚动到元素位置
        top: 0, //推荐使用。getBoundingClientRect 相对于当前视口的位置
        behavior: "smooth", // 平滑滚动
      });
    },
  },
};
</script>
<style lang="less">
.homelayout {
  .bodymain {
    min-height: calc(100vh - 395px);
  }
  .floatright {
    position: fixed;
    width: 75px;
    left: 10px;
    bottom: 13%;
    z-index: 999;
    padding-bottom: 40px;
    padding-top: 20px;
    > div {
      padding-top: 25px;
      cursor: pointer;
      position: relative;
      img {
        margin: 0 auto;
      }
      p {
        font-size: 14px;
        color: #666666;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
  .floatleft {
    position: fixed;
    width: 75px;
    right: 10px;
    bottom: 20%;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0px 10px 18px 0px rgba(241, 142, 86, 0.3);
    border-radius: 39px;
    padding-bottom: 40px;
    padding-top: 20px;
    > div {
      padding-top: 25px;
      cursor: pointer;
      position: relative;
      img {
        margin: 0 auto;
      }
      p {
        font-size: 14px;
        color: #666666;
        text-align: center;
        margin-top: 10px;
      }
      .sup {
        position: absolute;
        top: 14px;
        left: 7px;
        background-color: #f56c6c;
        border-radius: 50%;
        color: #fff;
        font-size: 12px;
        width: 23px;
        height: 23px;
        line-height: 23px;
        text-align: center;
        border: 1px solid #fff;
      }
    }
    .phone {
      position: relative;
      > div {
        width: 200px;
        text-align: center;
        position: absolute;
        right: -300px;
        top: 20px;
        background-color: #660874;
        padding: 10px 0px;
        font-weight: 700;
        border-radius: 8px;
        transition: all 0.3s;
        p {
          color: #fff;
          font-size: 24px;
          margin-top: 0;
        }
      }
      .current {
        right: 74px;
      }
    }
  }
}
</style>
